import { Injectable, ViewChild } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { CanDeactivateComponent } from './component-can-deactivate';
import { DialogService, DialogRef, DialogCloseResult } from '@progress/kendo-angular-dialog';
import { NgForm } from '@angular/forms';
import { Common } from 'src/app/common/common';
import { map } from 'rxjs/operators';
import * as $ from 'jquery';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanDeactivateComponent> {

    public result: any;
    @ViewChild('ngFormDirtyCheck')
    ngFormDirtyCheck: NgForm;

    constructor(private dialogService: DialogService) { }

    canDeactivate(component: CanDeactivateComponent): any {
        const Allform = document.querySelectorAll('.ng-dirty');
        if (!component.canDeactivate()) {
            Common.loader('hide');
            const dialog: DialogRef = this.dialogService.open({
                title: 'Please Confirm',
                content: 'You have unsaved changes! If you leave this tab, your changes will be lost. Would you like to save your changes?',
                actions: [
                    { text: "Don't save" },
                    { text: 'Save', primary: true }
                ],
                width: 550,
            });
            return dialog.result.pipe(map((result) => {
                if (result instanceof DialogCloseResult) {
                    return false;
                } else if (result.text === "Don't save") {
                    return true;
                } else {
                    if (component.componentName === 'awardEntryComponent') {
                        $('.awardEntrySave').click();
                    } else if (component.componentName === 'donorEntryComponent') {
                        $('.donorEntrySave').click();
                    }
                    return true;
                }
            }));
        } else if (Allform.length > 0) {
            if (!component.ngFormDirtyCheck.submitted) {
                Common.loader('hide');
                const dialog: DialogRef = this.dialogService.open({
                    title: 'Please Confirm',
                    content: 'You have unsaved changes! If you leave this tab, your changes will be lost. Would you like to save your changes?',
                    actions: [
                        { text: "Don't save" },
                        { text: 'Save', primary: true }
                    ],
                    width: 550,
                });
                return dialog.result.pipe(map((result) => {
                    if (result instanceof DialogCloseResult) {
                        return false;
                    } else if (result.text === "Don't save") {
                        return true;
                    } else {
                        if (component.targetPage === 1) {
                            $('.deliverableSave').click();
                        } else if (component.targetPage === 2) {
                            $('.priorApprovalSave').click();
                        } else if (component.targetPage === 3) {
                            $('.notesSave').click();
                        }
                        return true;
                    }
                }));
            } else {
                return true;
            }
        } else {
            return true;
        }
    }
}
